import { createSelector } from 'reselect';

import { inquiryApi } from './inquiryApi';
import { ICreateInquiryGetAttributesQueries, ICreateInquiryInitialise } from './types';

export const createInquirySectionAndTopicsSelector = (params: ICreateInquiryInitialise) =>
    inquiryApi.endpoints.getSectionsAndTopics.select(params);

export const createInquiryAttributesSelector = (params: ICreateInquiryGetAttributesQueries) =>
    inquiryApi.endpoints.getAttributes.select(params);

export const createInquiryCustomAttributesSelector = (params: ICreateInquiryGetAttributesQueries) =>
    createSelector(createInquiryAttributesSelector(params), (attr) => attr.data?.customAttrs ?? []);

export const createInquiryServiceAttributesSelector = (params: ICreateInquiryGetAttributesQueries) =>
    createSelector(createInquiryAttributesSelector(params), (attr) => attr.data?.serviceAttributes);

export const createInquiryIsSaveAvailableSelector = (params: ICreateInquiryGetAttributesQueries) =>
    createSelector(
        createInquiryServiceAttributesSelector(params),
        (serviceAttributes) => serviceAttributes?.saveAvailable,
    );

export const createInquiryDictionariesSelector = (params: ICreateInquiryGetAttributesQueries) =>
    createSelector(createInquiryAttributesSelector(params), (attr) => attr.data?.dictionaries ?? {});
